module.exports = __webpack_public_path__ + "static/media/16UNODC37.11b2de26.jpg";